<template>
  <svg
    class="ui-icon"
    v-if="icon.d"
    xmlns="http://www.w3.org/2000/svg"
    :width="iconSize.width"
    :height="iconSize.height"
    :viewBox="icon.viewBox"
    :class="classList"
    :style="styleList"
    :fill="fillRule"
    v-on="$listeners"
  >
    <path
      v-bind="$attrs"
      fill="inherit"
      :fill-rule="fillRule"
      :d="icon.d"
    />
  </svg>
</template>
<script>
const mapIcon = () => import('./mapIcon' /* webpackChunkName: "map-icons" */)
const ICON_TYPES = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  INFO: 'info',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  SECONDARY: 'secondary'
}

export default {
  name: 'UiIcon',
  inject: {
    customMapIcon: {
      from: 'mapIcon',
      default: () => []
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    size: Number,
    width: {
      type: Number,
      default: 16
    },
    height: Number,
    rotate: {
      type: Boolean,
      default: false
    },
    rotationDeg: {
      type: Number,
      default: 180
    },
    type: {
      type: String,
      validator (type) {
        if (!type) return true
        return Object.values(ICON_TYPES).includes(type)
      }
    }
  },

  data () {
    return {
      icon: {
        d: '',
        viewBox: ''
      },
      icons: []
    }
  },

  computed: {
    styleList () {
      return [
        {
          'min-width': `${this.iconSize.width}px`,
          transform: this.rotate ? `rotate(${this.rotationDeg}deg)` : null
        }
      ]
    },
    classList () {
      return [this.type ? `_type_${this.type}` : null]
    },
    iconSize () {
      return {
        height: this.size ?? this.height,
        width: this.size ?? this.width
      }
    },
    fillRule () {
      return this.icon.fillRule ?? 'evenodd'
    }
  },

  async created () {
    this.icons = { ...(await mapIcon()).default, ...this.customMapIcon }
    const icon = this.icons[this.name] || {}
    if (!icon) {
      console.error(`Иконка ${this.name} отсутствует`)
      this.icon = {}
      return
    }
    this.icon = icon
  },

  watch: {
    name () {
      this.icon = this.icons[this.name]
    }
  }
}
</script>
<style lang="scss" scoped>
.ui-icon {
  vertical-align: initial;

  &._type {
    &_default {
      fill: $gray-1;
    }

    &_primary {
      fill: $primary;
    }

    &_info {
      fill: $blue-1;
    }

    &_danger {
      fill: $red-1;
    }

    &_success {
      fill: $green-1;
    }

    &_warning {
      fill: $orange-2;
    }

    &_secondary {
      fill: $gray-3
    }
  }
}
</style>
